import { schema } from 'normalizr';

import { processOfficeGroup } from '../strategies/officeGroup';

export const officeGroupSchema = new schema.Entity('officeGroups', {}, { processStrategy: processOfficeGroup });

export const officeGroupEdgesSchema = [new schema.Object({ nodeId: officeGroupSchema })];
